<template>
 <component :is="currentComponent" :id="id" @change="onComponentChange" />
</template>

<script>
import { analyzeAgent } from '@/pc_login/isMobile.js'
import { Form, Field, Button, NavBar, Popup, Picker } from 'vant'
import Vue from 'vue'
import 'vant/lib/index.css'
import register from './register.vue'
import employeeInfo from './employee_info.vue'
import result from './result.vue'
Vue.use(Field)
Vue.use(Form)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Popup)
Vue.use(Picker)
export default {
  data () {
    return {
      currentComponent: 'register',
      id: null
    }
  },
  created () {
    if (!analyzeAgent(navigator.userAgent)) {
      this.$router.push({ path: '/auth', query: this.$route.query })
    }
  },
  components: {
    register,
    employeeInfo,
    result
  },
  methods: {
    onComponentChange (componet, id) {
      this.currentComponent = componet
      this.id = id
    }
  }
}
</script>

<style lang="less">
.van-field--min-height .van-field__control {
  min-height: 44px !important;
}

.van-field--error .van-field__control {
  color: #999;
}
.van-field--error .van-field__control::placeholder {
  color: #999;
}
</style>
